export const fr = {
  nav: {
    home: "Accueil",
    services: "Services",
    apartments: "Propriétés",
    about: "À propos",
    gallery: "Portfolio",
    blog: "Blog",
    contact: "Contact",
    bookNow: "Nous contacter",
    allServices: "Tous nos services",
    gestionLocative: "Gestion Locative",
    conciergerieService: "Conciergerie",
    aLaCarteService: "Prestations à la carte",
    bailMobiliteService: "Bail mobilité",
    yachtCharter: "Yacht Charter",
    billetterie: "Billetterie",
    automobiles: "Automobile",
    partnerLabel: "Partenaires",
    staffService: "Staff",
    faq: "FAQ",
    reviews: "Avis"
  },
  hero: {
    subtitle: "Services de vie d'exception",
    ownerTitle1: "Votre accès privilégié",
    ownerTitle2: "à la sérénité",
    title1: "Votre échappée belle",
    title2: "vers l'inoubliable",
    title3: "en",
    titleHighlight: "Provence",
    description: "Conciergerie spécialisée en location saisonnière, basée à Aix-en-Provence. Hébergements sélectionnés en\u00A0Provence.",
    cta: "Découvrir nos services",
    ctaSecondary: "Voir les propriétés",
    scrollDown: "Explorer"
  },
  footer: {
    description: "Conciergerie spécialisée en location saisonnière, basée à Aix-en-Provence. Hébergements sélectionnés en Provence.",
    quickLinks: "Navigation",
    services: "Services",
    contact: "Contact",
    newsletter: "Newsletter",
    newsletterDesc: "Recevez nos offres exclusives et actualités.",
    yourEmail: "Votre email",
    subscribe: "S'inscrire",
    allRights: "Tous droits réservés.",
    legal: "Mentions légales",
    privacy: "Politique de confidentialité",
    toasts: {
      invalidEmail: "Veuillez entrer une adresse email valide",
      alreadySubscribed: "Vous êtes déjà inscrit à notre newsletter !",
      thankYou: "Merci pour votre inscription !",
      subscribed: "Inscrit avec succès !",
      error: "Une erreur s'est produite. Veuillez réessayer."
    }
  },
  services: {
    subtitle: "Notre Expertise",
    title: "Nos Services",
    partnerSubtitle: "Partenariats Privilégiés",
    partnerTitle: "Services Annexes",
    partnerDescription: "Des experts de confiance qui partagent notre exigence du détail.",
    description: "Un ensemble de services conçu autour de votre style de vie sur la Côte d'Azur.",
    categories: {
      propertyManagement: {
        title: "Gestion Locative",
        subtitle: "Location Saisonnière",
        description: "Nous gérons votre bien de A à Z : annonces, réservations, accueil des voyageurs, ménage et maintenance.",
        features: [
          "Stratégie tarifaire dynamique adaptée au marché",
          "Photographie et vidéographie professionnelle",
          "Conciergerie 24/7 pour vos voyageurs",
          "Ménage et blanchisserie haut de gamme",
          "Maintenance et entretien préventif",
          "Gestion des réservations multi-plateforme",
          "Promotion active sur Instagram, Facebook, LinkedIn, TikTok et Google Ads",
          "Canal de réservation en direct via notre site — sans frais de service plateforme"
        ]
      },
      concierge: {
        title: "Conciergerie",
        subtitle: "Expériences Sur-Mesure",
        description: "Réservations, transferts, courses et organisation : nous nous occupons de tout pendant votre séjour.",
        features: [
          "Chefs privés",
          "Personnel de maison",
          "Réservations restaurants étoilés",
          "Accès VIP clubs et événements",
          "Coordination voyages et transferts",
          "Personal shopping et stylisme"
        ]
      },
      automotive: {
        title: "Automobile",
        subtitle: "Location & Expériences",
        description: "Location de véhicules de prestige et organisations d'expériences automobiles sur-mesure",
        features: [
          "Location de véhicules et de supercars avec livraison et reprise personnalisées",
          "Expériences sur circuit privatisées",
          "Visites privées de musées et collections",
          "Organisation de rallyes et d'événements automobiles",
          "Service de chauffeur privé"
        ]
      },
      yachting: {
        title: "Yacht Charter",
        subtitle: "Évasion Maritime",
        description: "L'horizon comme seule frontière. Naviguer vers l'ailleurs, là où le temps suspend son cours.",
        features: [
          "Charters journée et coucher de soleil",
          "Croisières semaine tout inclus",
          "Brokerage achat et vente de yachts",
          "Gestion équipage professionnel",
          "Itinéraires personnalisés",
          "Événements privés à bord"
        ]
      },
      events: {
        title: "Accès Exclusifs",
        subtitle: "Événements Privés",
        description: "Les portes qui ne s'ouvrent qu'aux initiés. Là où les moments deviennent légendes.",
        features: [
          "Festival de Cannes VIP",
          "Projections privées et avant-premières",
          "Semaines de la mode internationales",
          "Galas et soirées privées",
          "Expositions et vernissages art",
          "Concerts et événements sportifs"
        ]
      },
      staff: {
        title: "Staff",
        subtitle: "Personnel de Maison",
        description: "Chefs privés, personnel de maison et autres prestataires de services pour vos séjours ou événements.",
        features: ["Chefs privés", "Personnel de ménage", "Équipes de service", "Personnel événementiel", "Garde d'enfants qualifiée", "Personnel de sécurité", "Taxi / Chauffeur privé"]
      },
      ticketing: {
        title: "Billetterie",
        subtitle: "Accès Privilégiés",
        description: "Réservation de places pour événements, spectacles et manifestations culturelles.",
        features: ["Concerts et festivals", "Événements sportifs", "Spectacles et théâtres", "Salons et expositions", "Galas et soirées", "Événements privés"]
      },
      jet: {
        title: "Voyages & Logistique",
        subtitle: "Aviation Privée",
        description: "Nous gérons la logistique de voyage pour nos clients, garantissant une expérience sans faille et personnalisée.",
        features: ["Jets privés sur demande", "Hélicoptères", "Transferts aéroport VIP", "Vols long-courriers", "Service traiteur à bord", "Coordination bagages"]
      },
      watches: {
        title: "Montres & Bijoux",
        subtitle: "Pièces Iconiques",
        description: "Le temps capturé dans l'éclat d'un chef-d'œuvre. Des pièces qui traversent les époques.",
        features: ["Montres de collection", "Haute joaillerie", "Pièces vintage rares", "Authentification experte", "Ventes aux enchères", "Coffres-forts sécurisés"]
      }
    },
    cta: "En savoir plus",
    contactUs: "Nous contacter"
  },
  about: {
    subtitle: "Notre Identité",
    title: "Conciergerie Cabassol",
    description: "Conciergerie spécialisée en location saisonnière, basée à Aix-en-Provence. Hébergements sélectionnés en Provence, standards hôteliers. Propriétaires : gestion tout-inclus, interlocuteur dédié. Voyageurs : séjour sur-mesure, art de vivre local.",
    philosophy: {
      subtitle: "Notre Philosophie",
      title: "L'Attention aux Détails",
      description1: "Conciergerie Cabassol est une conciergerie de location saisonnière basée à Aix-en-Provence. Nous gérons des hébergements sélectionnés avec soin — appartements de charme, maisons de village, bastides, villas avec piscine — à Aix-en-Provence, dans le Pays d'Aix, et en Provence. Notre exigence : appliquer à chaque logement les standards de l'hôtellerie haut de gamme, avec un interlocuteur unique qui connaît le bien, le propriétaire et la région.",
      description2: "Pour les propriétaires, nous prenons en charge l'intégralité de la gestion locative dans une formule tout-inclus : shooting photo et vidéo par drone professionnel, création et diffusion de l'annonce sur les principales plateformes, optimisation tarifaire, promotion active sur les réseaux sociaux (Instagram, Facebook, LinkedIn, TikTok) et Google Ads, accueil des voyageurs, ménage, blanchisserie, maintenance et gestion des imprévus — 7 jours sur 7. Nous mettons également à votre disposition un canal de réservation en direct via notre site web, sans frais de service plateforme. Un seul interlocuteur, une transparence totale, et l'assurance que votre bien est valorisé et entretenu comme s'il était le nôtre.",
      description3: "Pour les voyageurs, nous proposons des hébergements où chaque détail a été pensé : linge soigné, propreté irréprochable, accueil personnalisé et recommandations locales — restaurants, marchés, plages, balades, adresses confidentielles. Nos équipes vivent ici, connaissent la Provence intimement et partagent avec chaque voyageur le meilleur de l'art de vivre local. Que vous veniez en famille, en couple ou entre amis, votre séjour est conçu sur-mesure.",
      cta: "Découvrir nos services"
    },
    values: {
      subtitle: "Ce Qui Nous Guide",
      title: "Nos Valeurs",
      items: [
        { title: "Confiance", description: "Relations sincères et partenariats durables fondés sur l'intégrité." },
        { title: "Sérénité", description: "Nous anticipons vos besoins pour vous offrir une tranquillité d'esprit totale." },
        { title: "Disponibilité", description: "Une équipe réactive à votre service 24/7." },
        { title: "Expertise", description: "Connaissance approfondie de la région et réseau de partenaires exclusif." }
      ]
    },
    timeline: {
      subtitle: "Notre Parcours",
      title: "Jalons Clés",
      milestones: [
        { year: "2020", title: "Fondation", description: "Création de Conciergerie Cabassol en Provence-Alpes-Côte d'Azur" },
        { year: "2022", title: "Événementiel", description: "Expansion vers l'organisation d'événements avec Antoine" },
        { year: "2025", title: "Yacht Charter", description: "Lancement du service yacht charter avec Alexander" },
        { year: "2026", title: "Automobile", description: "Développement des services automobiles de prestige avec Bowoods Travel" }
      ]
    },
    team: {
      subtitle: "Qui sommes-nous",
      title: "Personnel",
      description: "",
      members: [
        { name: "Eliott Sore-Larregain", role: "Gérant Conciergerie Cabassol", bio: "Expériences en hôtellerie et restauration, spécialiste de la gestion locative saisonnière, moyenne et longue durée." },
        { name: "Anastacia Figuière", role: "Responsable Partenariats & Prestataires", bio: "Spécialiste de la coordination des partenaires et prestataires, garante de la qualité de service et du développement du réseau." }
      ]
    },
    partners: {
      subtitle: "Notre Réseau",
      title: "Partenaires",
      description: "Des experts de confiance qui partagent notre exigence et notre sens du service personnalisé.",
      members: [
        { name: "Bowoods Travel", role: "Conciergerie Automobile", bio: "Passionné de véhicules d'exception, expert en location de supercars et expériences automobiles." },
        { name: "Alexander Suzanne", role: "Yacht Broker", bio: "Spécialiste du courtage yacht et des croisières de luxe en Méditerranée." },
        { name: "Antoine", role: "Conciergerie Événementielle", bio: "Expert en organisation d'événements privés et expériences exclusives sur la Côte d'Azur." }
      ]
    },
    cta: {
      title: "Devenez Partenaire",
      description: "Vous êtes un professionnel du tourisme, de l'événementiel ou du luxe ? Échangeons sur nos opportunités de collaboration.",
      button: "Nous Contacter"
    },
    yearsExperience: "Années d'expérience au service de clients exigeants"
  },
  properties: {
    subtitle: "La Sélection",
    title: "Nos hébergements",
    description: "Découvrez notre sélection d'hébergements.",
    viewAll: "Voir tout",
    perNight: "/nuitée",
    filters: {
      all: "Tout",
      villa: "Villas",
      apartment: "Appartements",
      location: "Localisation",
      capacity: "Capacité"
    },
    viewDetails: "Voir détails",
    guests: "voyageurs",
    bedrooms: "chambres"
  },
  contact: {
    subtitle: "Prise de contact",
    title: "Contactez-Nous",
    description: "Notre équipe est à votre disposition pour échanger sur vos projets et besoins.",
    infoTitle: "Informations",
    sendMessage: "Parlez-nous de votre projet",
    form: {
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      subject: "Sujet",
      message: "Votre message",
      send: "Envoyer",
      sending: "Envoi en cours...",
      success: "Message envoyé avec succès",
      error: "Une erreur est survenue"
    },
    info: {
      address: "Adresse",
      addressValue: "1 Traverse Notre-Dame, 13100 Aix-en-Provence",
      phone: "Téléphone",
      phoneValue: "+33 6 59 01 31 55",
      email: "Email",
      emailValue: "eliott@conciergeriecabassol.fr",
      hours: "Horaires",
      hoursValue: "Lun-Sam : 9h - 19h"
    }
  },
  stats: {
    properties: "Propriétés Gérées",
    clients: "Clients Satisfaits",
    years: "Années d'Expérience",
    availability: "Disponibilité"
  },
  testimonials: {
    subtitle: "Retours d'expérience",
    title: "Ils nous font confiance",
    description: "Ceux qui confient. Ceux qui séjournent.",
    viewAll: "Voir tous les avis"
  },
  reviewsPage: {
    metaTitle: "Avis Clients | Ils nous font confiance — Conciergerie Cabassol",
    metaDescription: "Découvrez les avis de nos clients sur Google. Conciergerie Cabassol : 5/5 étoiles pour la gestion locative et conciergerie en Provence.",
    title: "Ils nous font confiance",
    subtitle: "Retours d'expérience",
    description: "Ceux qui confient. Ceux qui séjournent.",
    leaveReview: "Laisser un avis sur Google"
  },
  cta: {
    title: "Votre Conciergerie,\nVotre Partenaire",
    description: "Un interlocuteur unique pour gérer, accueillir et sublimer vos séjours en Provence & Côte d'Azur.",
    button: "Nous contacter"
  },
  faq: {
    subtitle: "Questions Fréquentes",
    title: "Les réponses à vos questions",
    items: [
      {
        question: "Quels services proposez-vous aux propriétaires ?",
        answer: "Nous proposons une gestion locative complète : estimation des revenus, création d'annonces professionnelles, gestion des réservations, accueil des voyageurs, ménage, maintenance et reporting financier détaillé. Un interlocuteur unique gère l'ensemble pour vous."
      },
      {
        question: "Sur quelles zones géographiques intervenez-vous ?",
        answer: "Nous intervenons principalement sur le Pays d'Aix-en-Provence et collaborons avec des partenaires de confiance sur l'ensemble de la Provence et la Côte d'Azur, de Saint-Tropez à Monaco."
      },
      {
        question: "Comment fonctionne la conciergerie pour les voyageurs ?",
        answer: "Dès votre réservation confirmée, un conseiller dédié vous accompagne : recommandations personnalisées, réservations de restaurants, organisation d'excursions, location de véhicules, billetterie événementielle et toute demande sur-mesure."
      },
      {
        question: "Quels sont vos tarifs et y a-t-il des frais cachés ?",
        answer: "Nos tarifs sont transparents et adaptés à chaque prestation. La recherche d'hébergement est sans frais pour les voyageurs. Pour les propriétaires, nous proposons des formules claires avec un pourcentage sur les revenus locatifs. Contactez-nous pour un devis personnalisé."
      },
      {
        question: "Proposez-vous des services de yacht et automobile ?",
        answer: "Oui, grâce à nos partenaires spécialisés : location de yachts et croisières privées en Méditerranée avec Alexander, et location de supercars, expériences sur circuit et chauffeur privé avec Bowoods Travel."
      },
      {
        question: "Comment puis-je vous contacter et quel est le délai de réponse ?",
        answer: "Vous pouvez nous joindre via le formulaire de contact, par email à eliott@conciergeriecabassol.fr ou par téléphone. Nous garantissons une réponse sous 24h, 7 jours sur 7."
      }
    ]
  },
  gallery: {
    title: "Galerie Portfolio",
    subtitle: "Découvrez nos propriétés et expériences d'exception en images.",
    clickToEnlarge: "Cliquez pour agrandir",
    filters: {
      all: "Tout",
      exterior: "Extérieurs",
      rooms: "Intérieurs",
      amenities: "Équipements"
    }
  },
  notFound: {
    title: "Page Non Trouvée",
    description: "La page que vous recherchez n'existe pas ou a été déplacée.",
    returnHome: "Retour à l'accueil"
  },
  apartments: {
    title: "Nos hébergements",
    subtitle: "Découvrez notre sélection",
    filters: {
      guests: "Capacité",
      anyGuests: "Toute",
      location: "Localisation",
      allLocations: "Toutes",
      priceRange: "Prix",
      showing: "Affichage",
      of: "sur",
      accommodations: "propriétés",
      resetFilters: "Réinitialiser",
      noMatch: "Aucune propriété ne correspond",
      adjustFilters: "Essayez d'ajuster vos critères.",
      viewDetails: "Voir",
      features: "équipements",
      more: "plus",
      persons: "personnes",
      searchPlaceholder: "Rechercher par nom ou localisation...",
      region: "Région",
      allRegions: "Toutes les régions",
      sortBy: "Trier par",
      sortDefault: "Par défaut",
      sortPriceAsc: "Prix croissant",
      sortPriceDesc: "Prix décroissant",
      sortCapacityDesc: "Capacité (max → min)",
      sortCapacityAsc: "Capacité (min → max)",
      sortSizeDesc: "Surface (max → min)",
      sortSizeAsc: "Surface (min → max)",
      allPrices: "Tous les prix",
      upTo: "Jusqu'à",
      moreThan: "Plus de",
      gridView: "Vue grille",
      listView: "Vue liste"
    }
  },
  apartmentDescriptions: {
    "1": { 
      name: "Villa Azure", 
      description: "Villa d'exception en front de mer",
      longDescription: "Perchée sur les falaises du Cap d'Antibes, Villa Azure offre une vue panoramique époustouflante sur la Méditerranée. Ce chef-d'œuvre architectural allie élégance provençale et luxe moderne, avec 6 suites, piscine à débordement et accès plage privée.",
      features: ["Piscine à débordement", "Plage privée", "Cinéma maison", "Cave à vins", "Cuisine de chef", "Spa & sauna"],
      highlights: ["Accès direct mer", "Vue panoramique 360°", "Jardins paysagers"]
    },
    "2": { 
      name: "Château Provence", 
      description: "Domaine provençal historique",
      longDescription: "Magnifique château du 17ème siècle niché dans les collines du Luberon. Ce domaine d'exception s'étend sur 15 hectares de champs de lavande et d'oliviers, offrant un mélange unique de charme historique et de confort contemporain.",
      features: ["Piscine chauffée", "Court de tennis", "Orangerie", "Chapelle", "Maison d'amis", "Potager bio"],
      highlights: ["15 hectares de terrain", "Architecture historique", "Vignoble"]
    },
    "3": { 
      name: "Palais Cannes", 
      description: "Penthouse ultra-luxe",
      longDescription: "Situé sur la prestigieuse Croisette, ce penthouse d'exception offre une vue imprenable sur la baie de Cannes et les îles de Lérins. 450m² de vie raffinée avec terrasse rooftop et piscine privée.",
      features: ["Piscine rooftop", "Ascenseur privé", "Domotique", "Cave à vins", "Salle de sport", "Concierge 24/7"],
      highlights: ["Emplacement Croisette", "Vue baie panoramique", "Accès Festival"]
    },
    "4": { 
      name: "Villa Méditerranée", 
      description: "Villa contemporaine vue mer",
      longDescription: "Joyau architectural contemporain sur les hauteurs de Saint-Jean-Cap-Ferrat. Lignes épurées et baies vitrées du sol au plafond encadrent des vues imprenables sur la Méditerranée. Piscine à débordement et jardin méditerranéen luxuriant.",
      features: ["Piscine à débordement", "Pool house", "Cuisine design", "Maison connectée", "Borne voiture électrique", "Cuisine extérieure"],
      highlights: ["Architecture contemporaine", "Vue mer dégagée", "Emplacement prime"]
    },
    "5": { 
      name: "Bastide Provençale", 
      description: "Bastide du 18ème siècle",
      longDescription: "Authentique bastide du 18ème siècle méticuleusement restaurée au cœur de la Provence. Cette propriété allie charme d'époque et prestations modernes, entourée de 5 hectares de parc arboré centenaire.",
      features: ["Piscine & pool house", "Terrain de pétanque", "Cuisine d'été", "Cheminées en pierre", "Cave voûtée", "Maison gardien"],
      highlights: ["Charme authentique", "5 hectares de parc", "Tranquillité absolue"]
    },
    "6": { 
      name: "Villa Port Grimaud", 
      description: "Villa vénitienne sur l'eau",
      longDescription: "Au cœur de la cité lacustre de Port Grimaud, cette villa d'exception ouvre ses portes sur les canaux et la Méditerranée. Architecture vénitienne, ponton privé et vue imprenable sur le golfe de Saint-Tropez.",
      features: ["Ponton privé", "Accès direct mer", "Terrasse sur l'eau", "Garage bateau", "Vue sur le golfe", "Jardin méditerranéen"],
      highlights: ["Cité lacustre unique", "À quelques minutes de Saint-Tropez", "Charme vénitien"]
    },
    "7": { 
      name: "Villa Tropézienne", 
      description: "Villa légendaire Saint-Tropez",
      longDescription: "Villa iconique surplombant le golfe de Saint-Tropez. Cette propriété légendaire a accueilli stars et têtes couronnées, offrant 12 chambres, piscine à débordement avec pool house, et accès direct à la plage de Pampelonne.",
      features: ["Piscine à débordement", "Pool house", "Accès plage privée", "Home cinéma", "Cuisine professionnelle", "Salle de sport"],
      highlights: ["Vue golfe de Saint-Tropez", "Plage de Pampelonne", "Héritage de stars"]
    },
    "8": { 
      name: "Mas des Oliviers", 
      description: "Mas provençal authentique",
      longDescription: "Charmant mas du 19ème siècle niché au milieu des oliviers et des champs de lavande. Cette propriété authentique a été amoureusement restaurée pour offrir un confort moderne tout en préservant son âme provençale. 8 chambres, piscine chauffée.",
      features: ["Piscine chauffée", "Oliveraie", "Cuisine d'été", "Terrain de pétanque", "Cave à vin", "Jardin paysager"],
      highlights: ["Authenticité provençale", "Oliviers centenaires", "Sérénité absolue"]
    },
    "9": { 
      name: "Appartement Palais Maeterlinck", 
      description: "Appartement prestige Nice",
      longDescription: "Appartement d'exception dans le légendaire Palais Maeterlinck, ancienne résidence du Prix Nobel. 280m² avec vue mer, accès à la plage privée, piscine chauffée et spa de la résidence.",
      features: ["Plage privée", "Piscine chauffée", "Spa", "Concierge", "Parking sécurisé", "Terrasse mer"],
      highlights: ["Palais historique", "Vue mer 180°", "Services 5 étoiles"]
    },
    "10": { 
      name: "Villa Cap Ferrat", 
      description: "Domaine d'exception Cap Ferrat",
      longDescription: "Une des dernières propriétés disponibles sur le prestigieux Cap. Cette villa d'exception offre une vue à 180° sur la Méditerranée, 3 hectares de jardins paysagers, piscine olympique et héliport privé.",
      features: ["Piscine olympique", "Héliport", "Logement personnel", "Court de tennis", "Ponton privé", "Jardin tropical"],
      highlights: ["Emplacement unique", "Intimité totale", "Prestige ultime"]
    },
    "11": { 
      name: "Loft Vieux Nice", 
      description: "Loft design Vieux Nice",
      longDescription: "Loft d'exception de 350m² dans un immeuble rénové du 18ème siècle. Cet espace unique allie charme historique et design contemporain, avec une terrasse rooftop privée offrant une vue panoramique sur Nice.",
      features: ["Terrasse rooftop", "Cuisine design", "Hauteurs sous plafond", "Domotique", "Parking sécurisé", "Cave à vin"],
      highlights: ["Charme historique", "Vue panoramique", "Emplacement central"]
    },
    "12": { 
      name: "Domaine Sainte-Victoire", 
      description: "Domaine face à Sainte-Victoire",
      longDescription: "Domaine d'exception au pied de la montagne Sainte-Victoire, inspiration de Cézanne. 20 hectares de vignes et d'oliviers, maison principale de 10 chambres, 2 maisons d'amis et cave avec production annuelle.",
      features: ["Vignoble exploité", "Oliveraie", "Piscine à débordement", "Maisons d'amis", "Cave privée", "Installations équestres"],
      highlights: ["Vue Cézanne", "Production viticole", "Domaine exceptionnel"]
    },
    "13": { 
      name: "Villa Éze", 
      description: "Nid d'aigle méditerranéen",
      longDescription: "Perchée dans le village médiéval d'Èze, cette villa d'exception offre des vues vertigineuses sur la Grande Bleue. Architecture provençale rénovée avec goût, jardins en terrasse et piscine suspendue entre ciel et mer.",
      features: ["Piscine panoramique", "Jardins en terrasse", "Cave voûtée", "Terrasse rooftop", "Hammam", "Garage sécurisé"],
      highlights: ["Village perché", "Vue 270°", "Atmosphère médiévale"]
    },
    "14": { 
      name: "Bastide des Alpilles", 
      description: "Bastide au cœur des Alpilles",
      longDescription: "Majestueuse bastide du 19ème siècle nichée dans le parc naturel des Alpilles. Entourée d'oliviers centenaires et de cyprès, cette propriété de 8 hectares allie charme provençal et prestations de luxe.",
      features: ["Piscine chauffée 18m", "Court de tennis", "Oliveraie bio", "Pool house", "Maison gardien", "Potager"],
      highlights: ["Parc naturel Alpilles", "8 hectares privatifs", "Authenticité préservée"]
    },
    "15": { 
      name: "Penthouse Croisette", 
      description: "Penthouse vue Festival",
      longDescription: "Au dernier étage d'une résidence Art Déco sur la Croisette, ce penthouse de 400m² domine le Palais des Festivals. Terrasse panoramique avec jacuzzi, intérieurs signés par un architecte de renom.",
      features: ["Terrasse 150m²", "Jacuzzi extérieur", "Ascenseur privatif", "Domotique complète", "Concierge 24h", "2 parkings"],
      highlights: ["Face Palais Festivals", "Décoration architecte", "Vue Baie de Cannes"]
    },
    "16": { 
      name: "Mas de Gordes", 
      description: "Mas d'artiste à Gordes",
      longDescription: "Ancien mas d'artiste dans le village classé de Gordes. Cette propriété de caractère a conservé son authenticité avec pierres apparentes, poutres anciennes et tomettes, tout en offrant un confort contemporain haut de gamme.",
      features: ["Piscine naturelle", "Atelier d'artiste", "Cuisine d'été", "Terrasses ombragées", "Cave à vin", "Jardin provençal"],
      highlights: ["Village classé", "Cachet artistique", "Vue vallée Luberon"]
    },
    "17": { 
      name: "Villa Beaulieu-sur-Mer", 
      description: "Villa Belle Époque Beaulieu",
      longDescription: "Somptueuse villa Belle Époque sur le front de mer de Beaulieu. Cette demeure historique a été minutieusement restaurée, alliant moulures d'époque et confort moderne. Accès direct à la mer et ponton privé.",
      features: ["Accès mer direct", "Ponton privé", "Piscine d'eau de mer", "Salon de musique", "Orangerie", "Jardins français"],
      highlights: ["Architecture Belle Époque", "Front de mer", "Histoire & prestige"]
    },
    "18": { 
      name: "Château Mougins", 
      description: "Château contemporain Mougins",
      longDescription: "Château réinventé au cœur de Mougins, village des gastronomes. Architecture contemporaine audacieuse intégrée dans 4 hectares de parc méditerranéen. Espace bien-être, salle de réception et héliport.",
      features: ["Spa complet", "Salle de réception", "Héliport", "Cave de collection", "Tennis", "Personnel logé"],
      highlights: ["Village gastronomique", "Architecture unique", "4 hectares de parc"]
    },
    "19": { 
      name: "Appartement Port Hercule", 
      description: "Appartement vue Port Hercule",
      longDescription: "Rare appartement de 320m² avec terrasse sur le mythique Port Hercule de Monaco. Emplacement exceptionnel pour le Grand Prix et les événements nautiques. Finitions de prestige et services résidence de luxe.",
      features: ["Terrasse 80m²", "Vue Port & Palais", "Parking double", "Cave", "Accès plage", "Conciergerie"],
      highlights: ["Vue Grand Prix", "Port Hercule", "Emplacement iconique"]
    },
    "20": { 
      name: "Domaine Valbonne", 
      description: "Domaine équestre Valbonne",
      longDescription: "Exceptionnel domaine équestre dans l'arrière-pays cannois. 15 hectares avec manège couvert, écuries de 12 boxes, maison principale et 2 dépendances. Cadre préservé entre oliviers et chênes centenaires.",
      features: ["Manège couvert", "12 boxes", "Carrière olympique", "Piscine chauffée", "2 dépendances", "Forêt privée"],
      highlights: ["Domaine équestre", "15 hectares boisés", "Intimité absolue"]
    },
    "21": { 
      name: "Villa Sainte-Victoire", 
      description: "Villa de charme avec vue Sainte-Victoire",
      longDescription: "Villa de charme avec piscine et vue panoramique sur la Sainte-Victoire, proche du Lac de Bimont et du centre-ville d'Aix-en-Provence. 5 chambres, 2 salons, 3 terrasses pour des séjours inoubliables en Provence.",
      features: ["Piscine vue Sainte-Victoire", "5 chambres", "2 salons", "3 terrasses", "Grand jardin", "Parking privé", "Climatisation", "Randonnée accessible"],
      highlights: ["Vue Sainte-Victoire", "Proche Lac de Bimont", "5 chambres spacieuses"]
    },
    "22": { 
      name: "Bastide Aix Centre", 
      description: "Bastide XIXe avec piscine en centre-ville",
      longDescription: "Villa de charme avec piscine et vue panoramique en plein centre-ville d'Aix-en-Provence. Ancien poste de garde du XIXe siècle, jardin de 1000m². Idéal pour découvrir Aix-en-Provence et la Provence.",
      features: ["Piscine", "Vue panoramique ville", "3 suites", "Jardin 1000m²", "Centre-ville 2 min", "Climatisation", "Terrasses", "Parking privé"],
      highlights: ["Centre-ville Aix", "Bâtiment historique XIXe", "Jardin 1000m²"]
    },
    "23": { 
      name: "Appartement Aix Centre", 
      description: "Meublé lumineux vue Cathédrale",
      longDescription: "Charmant meublé de 40m² très lumineux au 3e étage avec vue sur la Cathédrale Saint-Sauveur et les toits du centre historique. À 200m de l'Hôtel de Ville, balcon plein sud.",
      features: ["Vue Cathédrale", "Balcon 5m² plein sud", "Cuisine équipée", "Lave-linge", "Cafetière Nespresso", "Climatisation", "Lit 2 places", "Centre-ville 200m", "Quartier calme"],
      highlights: ["Vue Cathédrale Saint-Sauveur", "Hyper centre historique", "Balcon plein sud"]
    },
    "24": { 
      name: "Villa Cap d'Antibes", 
      description: "Villa méditerranéenne vue mer panoramique",
      longDescription: "Somptueuse villa méditerranéenne avec piscine à débordement et vue panoramique sur la mer. Accès privé aux criques, jardin paysager de 2000m². 6 chambres luxueuses au Cap d'Antibes.",
      features: ["Piscine à débordement", "Vue mer panoramique", "6 chambres", "5 Salles de bains", "Accès plage privé", "Jardin 2000m²", "Cuisine d'été", "Climatisation", "Parking 4 véhicules"],
      highlights: ["Cap d'Antibes", "Vue mer 180°", "Accès criques privées"]
    },
    "25": { 
      name: "Mas du Luberon", 
      description: "Mas en pierre dorée au cœur du Luberon",
      longDescription: "Authentique mas en pierre dorée au cœur du Luberon. Piscine entourée de lavandes, oliveraie centenaire et vue sur les collines provençales. 4 chambres pour un séjour provençal authentique.",
      features: ["Piscine chauffée", "Champs de lavande", "4 chambres", "3 Salles de bains", "Oliveraie", "Terrasse ombragée", "Cuisine provençale", "Climatisation", "Parking"],
      highlights: ["Cœur du Luberon", "Pierre dorée authentique", "Champs de lavande"]
    },
    "26": { 
      name: "Appartement Saint-Tropez", 
      description: "Appartement design au cœur de Saint-Tropez",
      longDescription: "Élégant appartement contemporain au cœur de Saint-Tropez. Design luxueux avec cuisine équipée en noyer, terrasse privée et finitions haut de gamme. À quelques minutes des plages.",
      features: ["Cuisine design", "Terrasse privée", "2 chambres", "1 Salle de bains", "Climatisation", "Parquet chevron", "Proche plages", "Centre-ville 5 min"],
      highlights: ["Cœur de Saint-Tropez", "Design contemporain", "Terrasse privée"]
    },
    "27": { 
      name: "Cabane A-Frame", 
      description: "Cabane atypique avec jacuzzi en Provence",
      longDescription: "Cabane atypique en forme de A avec jacuzzi privatif et terrasse en bois. Une expérience unique au cœur de la nature provençale, idéale pour un séjour romantique.",
      features: ["Jacuzzi privatif", "Terrasse bois", "1 chambre", "Vue nature", "Climatisation", "Lit king-size", "Cuisine équipée", "Isolation thermique"],
      highlights: ["Architecture A-Frame unique", "Jacuzzi privatif", "Nature provençale"]
    },
    "28": {
      name: "Villa Vauvenargues",
      description: "Villa de charme au pied de la Sainte-Victoire",
      longDescription: "Villa de charme au pied de la Sainte-Victoire, dans le village cher à Picasso. Piscine, jardin méditerranéen et vue imprenable sur la montagne.",
      features: ["Piscine", "4 chambres", "3 Salles de bains", "Vue Sainte-Victoire", "Jardin méditerranéen", "Climatisation", "Terrasse", "Parking privé", "Cheminée"],
      highlights: ["Village de Picasso", "Vue Sainte-Victoire", "Jardin méditerranéen"]
    },
    "29": {
      name: "Bastide Auriol",
      description: "Bastide provençale dans les collines du Garlaban",
      longDescription: "Bastide provençale dans les collines du Garlaban, pays de Pagnol. Piscine, oliveraie et calme absolu au cœur de la Provence authentique.",
      features: ["Piscine", "3 chambres", "2 Salles de bains", "Vue collines", "Oliveraie", "Climatisation", "Terrasse ombragée", "Parking", "Barbecue"],
      highlights: ["Collines du Garlaban", "Pays de Pagnol", "Calme absolu"]
    }
  },
  booking: {
    accommodationSelect: { continue: "Continuer" },
    summary: { night: "nuitée", nights: "nuitées" }
  },
  bookingForm: {
    title: "Estimation Gratuite",
    propertyType: "Type de bien",
    selectPropertyType: "Sélectionner",
    villa: "Villa",
    apartment: "Appartement",
    house: "Maison",
    penthouse: "Penthouse",
    location: "Localisation",
    selectLocation: "Sélectionner",
    cannes: "Cannes",
    nice: "Nice",
    saintTropez: "Saint-Tropez",
    antibes: "Antibes",
    monaco: "Monaco",
    marseille: "Marseille",
    aixEnProvence: "Aix-en-Provence",
    other: "Autre",
    surface: "Surface (m²)",
    surfacePlaceholder: "Ex: 150",
    bedrooms: "Chambres",
    bathrooms: "Salles de bain",
    amenities: "Équipements",
    pool: "Piscine",
    panoramicView: "Vue panoramique",
    waterfront: "Bord de mer",
    garden: "Jardin",
    parking: "Parking",
    airConditioning: "Climatisation",
    firstName: "Prénom",
    firstNamePlaceholder: "Votre prénom",
    lastName: "Nom",
    lastNamePlaceholder: "Votre nom",
    email: "Email",
    emailPlaceholder: "votre@email.fr",
    phone: "Téléphone",
    phonePlaceholder: "+33 6 00 00 00 00",
    address: "Adresse",
    addressPlaceholder: "Adresse du bien",
    checkAvailability: "Obtenir une estimation",
    bookingConfirmed: "Demande envoyée !"
  },
  estimation: {
    subtitle: "Gestion Locative",
    title: "Découvrez le Potentiel de Votre Propriété",
    description: "Obtenez une estimation gratuite du potentiel locatif de votre bien.",
    progress: "Progression",
    benefits: {
      freeEstimate: "Estimation gratuite revenus locatifs",
      revenueOptimization: "Optimisation des revenus",
      turnkeyManagement: "Gestion clé en main",
      insuranceIncluded: "Assurance incluse"
    }
  },
  travelerSearch: {
    subtitle: "Voyageurs",
    title: "Trouvez Votre Séjour Idéal",
    description: "Décrivez vos envies et notre équipe vous proposera une sélection personnalisée de biens correspondant à vos critères.",
    benefits: {
      response24h: "Réponse sous 24h",
      personalizedSelection: "Sélection personnalisée",
      noBookingFees: "Sans frais de réservation",
      dedicatedAdvisor: "Conseiller dédié"
    },
    destination: "Destination",
    selectDestination: "Sélectionner",
    destinations: {
      aixEnProvence: "Aix-en-Provence",
      luberon: "Luberon",
      alpilles: "Alpilles",
      gordes: "Gordes",
      coteDAzur: "Côte d'Azur",
      saintTropez: "Saint-Tropez",
      other: "Autre"
    },
    arrivalDate: "Arrivée",
    departureDate: "Départ",
    selectDate: "Sélectionner",
    guests: "Voyageurs",
    selectGuests: "Nombre",
    propertyType: "Type de bien",
    selectPropertyType: "Peu importe",
    propertyTypes: {
      villa: "Villa",
      apartment: "Appartement",
      mas: "Mas / Bastide",
      any: "Peu importe"
    },
    budget: "Budget / nuit",
    selectBudget: "Optionnel",
    budgets: {
      under200: "Moins de 200€",
      from200to500: "200€ - 500€",
      from500to1000: "500€ - 1 000€",
      over1000: "Plus de 1 000€"
    },
    firstName: "Prénom",
    firstNamePlaceholder: "Votre prénom",
    email: "Email",
    emailPlaceholder: "votre@email.fr",
    phone: "Téléphone",
    phonePlaceholder: "+33 6 00 00 00 00",
    message: "Préférences / Message",
    messagePlaceholder: "Ex: vue mer, piscine, proche centre-ville...",
    submit: "Envoyer ma demande",
    submitting: "Envoi en cours...",
    submitted: "Demande envoyée !",
    progress: "Progression"
  },
  contactProfiles: {
    selectProfile: "Cliquez pour choisir votre profil",
    traveler: "Voyageur",
    travelerDesc: "Je cherche un hébergement",
    owner: "Propriétaire",
    ownerDesc: "Je souhaite une estimation",
    other: "Autre",
    otherDesc: "Autre demande",
    yourCoordinates: "Vos Coordonnées",
    howCanWeHelp: "Comment pouvons-nous vous aider ?",
    sendTheMessage: "Envoyer le message",
    otherBenefits: ["Réponse sous 24h", "Équipe à votre écoute", "Sans engagement"]
  },
  blog: {
    subtitle: "Blog",
    title: "Tips & Actualités",
    description: "Restez informé des dernières tendances, conseils et insights des experts en gestion de propriétés de luxe sur la Côte d'Azur.",
    backToBlog: "← Retour au Blog",
    readMore: "Lire la suite",
    featured: "À la une",
    noArticles: "Aucun article trouvé pour cette catégorie.",
    ctaTitle: "Prêt à Maximiser le Potentiel de Votre Propriété ?",
    ctaDescription: "Obtenez votre analyse de propriété gratuite et découvrez comment nos services de gestion professionnelle peuvent augmenter vos revenus locatifs.",
    ctaButton: "Demander une Estimation Gratuite"
  },
  home: {
    welcome: { subtitle: "Bienvenue", title: "Services Haut de Gamme", description1: "Des services d'exception adaptés à votre style de vie.", description2: "Nous anticipons chacun de vos désirs.", learnMore: "En savoir plus" },
    booking: { subtitle: "Estimation", title: "Découvrez le potentiel de votre propriété", description: "Obtenez une estimation gratuite de vos revenus locatifs.", benefits: ["Estimation gratuite", "Optimisation des revenus", "Gestion clé en main"] },
    featuredApartments: { subtitle: "Portfolio", title: "Propriétés à la une", description: "Une sélection pointue de biens d'exception.", viewAll: "Voir tout" },
    amenities: {
      subtitle: "Services",
      title: "Notre Expertise",
      description: "Un ensemble de services conçus autour de vos besoins.",
      features: {
        beachfront: { title: "Propriétés en bord de mer", description: "Villas exclusives avec accès direct à la plage." },
        pools: { title: "Piscines privées", description: "Piscines à débordement surplombant la Méditerranée." },
        restaurant: { title: "Chefs privés", description: "Expériences gastronomiques à domicile." },
        wifi: { title: "Maisons intelligentes", description: "Technologie de pointe pour un confort maximal." },
        bar: { title: "Caves à vins", description: "Sélections de grands crus." },
        location: { title: "Emplacements d'exception", description: "Les adresses les plus prestigieuses de la Riviera." }
      }
    },
    cta: { title: "Prêt à vivre l'inattendu ?", description: "Contactez-nous pour découvrir nos services.", bookNow: "Nous contacter" },
    location: {
      basedIn: "Conciergerie basée à",
      partnerNetwork: "Réseau de partenaires",
      withPartner: "avec",
      estimateCta: "Demander une estimation",
      bookCta: "Réserver un hébergement",
      servicesDescription: "Basés à Aix-en-Provence, nous opérons directement sur le Pays d'Aix et collaborons avec des conciergeries partenaires sur l'ensemble de la Provence & Côte d'Azur.",
      leadFormDescription: "Voyageur, propriétaire ou simple curiosité — décrivez-nous votre besoin et recevez une réponse personnalisée sous 24h.",
      available7days: "Disponible 7j/7",
      noCommitment: "Sans engagement",
      response24h: "Réponse sous 24h",
      anotherQuestion: "Une autre question ?"
    },
    badges: { exclusive: "Exclusif", new: "Nouveau", favorite: "Coup de cœur", atypical: "Atypique" },
    blogSection: { subtitle: "Blog", title: "Tips & Actus", description: "Découvrez nos articles pour optimiser la location et la gestion de votre bien.", viewAll: "Voir tous les articles", readMore: "Lire l'article", filterAll: "Tous" }
  },
  amenitiesPage: {
    title: "Nos Services",
    subtitle: "Des Services À Votre Mesure",
    description: "Découvrez notre gamme complète de services de luxe conçus pour les clients les plus exigeants.",
    categories: {
      wellness: { title: "Bien-être & Spa", description: "Régénérez corps et esprit avec nos partenaires bien-être.", items: ["Soins spa à domicile", "Coachs personnels", "Instructeurs de yoga", "Esthéticiennes"] },
      dining: { title: "Gastronomie", description: "Expériences culinaires d'exception.", items: ["Chefs privés", "Service traiteur", "Sommelier", "Réservations restaurants étoilés"] },
      services: { title: "Conciergerie", description: "Assistance 24/7 pour tous vos besoins.", items: ["Transferts VIP", "Personal shopping", "Organisation d'événements", "Coordination voyages"] },
      entertainment: { title: "Divertissement", description: "Expériences et activités exclusives.", items: ["Charter yacht", "Location supercars", "Accès événements VIP", "Visites privées"] }
    }
  },
  servicePages: {
    offer: {
      sectionLabel: "Nos formules",
      sectionTitle: "Notre offre",
      sectionDescription: "Notre formule tout-inclus prend en charge votre bien de A à Z. Les prestations à la carte restent disponibles pour les propriétaires qui gèrent eux-mêmes leurs réservations.",
      main: {
        badge: "NOTRE CŒUR DE MÉTIER",
        title: "Notre formule \"Gestion complète\" tout-inclus",
        subtitle: "Gestion locative saisonnière de A à Z.",
        price: "20 %",
        priceUnit: "des revenus locatifs nets",
        priceNote: "Une commission unique, prélevée uniquement quand votre bien est loué.",
        intro: "Aucun frais d'entrée, aucun abonnement, aucune prestation facturée en supplément. Le ménage, la blanchisserie, l'accueil, la maintenance et le suivi sont compris dans la commission.",
        leftHighlights: [
          "Commission au succès — vous ne payez rien tant que votre bien n'est pas loué",
          "Aucun frais de dossier, de mise en service ni d'abonnement",
          "Sans engagement de durée",
          "Ménage professionnel et blanchisserie inclus à chaque rotation"
        ],
        rightHighlights: [
          "Diffusion multi-plateformes internationale (Airbnb, Abritel, Booking, Expedia, Hotels.com…)",
          "Accueil des voyageurs, maintenance et assistance 7 jours sur 7",
          "Stratégie construite pour votre bien : saisonnier seul ou hybride avec bail mobilité",
          "Commission ramenée à 10 % sur les locations de plus de trois mois"
        ],
        cta: "Découvrir la Gestion complète"
      },
      secondary: {
        title: "Prestations à la carte",
        subtitle: "MÉNAGE, LINGE ET CONSOMMABLES",
        price: "Dès 55 €",
        priceUnit: "par rotation",
        intro: "Vous gérez vous-même vos réservations et souhaitez déléguer l'exploitation sur place.",
        priceRows: [
          { label: "Ménage entre séjours", price: "dès 55 €" },
          { label: "Linge, par lit préparé", price: "10 à 20 €" },
          { label: "Consommables", price: "12 € par rotation" }
        ],
        highlights: [
          "Sans commission sur vos revenus",
          "Sans engagement de durée",
          "Facturation mensuelle",
          "Prestataires assurés et contrôlés"
        ],
        cta: "Voir la grille tarifaire"
      },
      includedTitle: "Inclus sans supplément",
      included: [
        { title: "Shooting vidéo par drone", description: "Intérieur et extérieur, réalisé en interne. Votre annonce se distingue dès la vignette." },
        { title: "Canal de réservation en direct", description: "Une page dédiée à votre bien sur notre site. Aucun frais de service, aucune commission supplémentaire." },
        { title: "Promotion active du bien", description: "Instagram, Facebook, LinkedIn, TikTok et campagnes Google Ads. Nous allons chercher les voyageurs." }
      ],
      hybrid: {
        label: "Stratégie personnalisée",
        title: "Saisonnier en haute saison, bail mobilité en basse saison",
        description: "Nous construisons une stratégie locative adaptée aux caractéristiques réelles de votre bien. À Aix-en-Provence, la stratégie hybride permet à votre logement de générer des revenus douze mois sur douze, tout en restant sous votre maîtrise.",
        cta: "Découvrir la stratégie hybride"
      }
    },
    learnMore: "En savoir plus",
    gestionLocative: {
      seoTitle: "Gestion Locative Saisonnière Aix-en-Provence | Formule tout-inclus 20 %",
      seoDescription: "Gestion locative saisonnière à Aix-en-Provence. Formule tout-inclus à 20 % des revenus locatifs nets : shooting drone, diffusion multi-plateformes, ménage et blanchisserie inclus, accueil, maintenance, stratégie hybride bail mobilité. Estimation gratuite.",
      heroTitle: "Gestion Locative à Aix-en-Provence",
      heroSubtitle: "Gestion Locative",
      heroDescription: "Confiez la gestion de votre bien à Conciergerie Cabassol. Pour 20 % des revenus locatifs nets, nous prenons en charge l'intégralité de l'exploitation : de la séance photo à l'accueil des voyageurs, du ménage au suivi des revenus. Nous accompagnons un nombre limité de propriétaires afin de consacrer à chacun l'attention qu'il mérite.",
      sections: [
        {
          title: "Un engagement simple, un service complet",
          description: "Pour 20 % des revenus locatifs nets, l'ensemble de nos prestations est inclus. Pas de frais d'installation, pas de frais de mise en service, pas de supplément à l'arrivée d'un voyageur.",
          features: [
            "20 % des revenus locatifs nets, sans frais annexes",
            "Ménage professionnel et blanchisserie inclus à chaque réservation",
            "Préparation approfondie du logement avant chaque arrivée",
            "Consommables : 10 € par réservation, achat et réapprovisionnement compris",
            "Aucun engagement de durée"
          ]
        },
        {
          title: "Commercialisation et visibilité",
          description: "Votre bien mérite d'être présenté avec soin. Nous soignons chaque annonce pour qu'elle reflète la qualité réelle de votre propriété et attire les voyageurs qui lui correspondent.",
          features: [
            "Shooting photo et vidéo par drone, retouches professionnelles",
            "Rédaction de l'annonce et optimisation de son référencement sur les plateformes",
            "Mise en valeur du logement et recommandations d'aménagement",
            "Promotion sur Instagram, Facebook, LinkedIn, TikTok et via des campagnes Google Ads"
          ]
        },
        {
          title: "Diffusion internationale multi-plateformes",
          description: "Une annonce, une seule interlocutrice, une visibilité maximale. Votre calendrier est synchronisé en permanence : aucun risque de double réservation.",
          features: [
            "Airbnb",
            "Booking.com",
            "Abritel et le réseau Expedia : Vrbo, Expedia, Hotels.com",
            "Votre canal de réservation en direct, hébergé sur notre site, sans frais de service ni commission supplémentaire"
          ]
        },
        {
          title: "Stratégie locative personnalisée",
          description: "Tous les biens ne se louent pas de la même manière. Nous construisons votre calendrier annuel à partir de votre emplacement, de votre typologie et de la saisonnalité réellement observée : saisonnier toute l'année, ou stratégie hybride avec bail mobilité en basse saison.",
          features: [
            "Analyse de la saisonnalité réelle de votre bien",
            "Arbitrage entre saisonnier seul et stratégie hybride",
            "Bail mobilité de 1 à 10 mois pendant les mois creux, votre bien reste libre pour l'été",
            "Commission ramenée à 10 % sur toute location continue de plus de trois mois"
          ]
        },
        {
          title: "Tarification et suivi",
          description: "Vos prix évoluent avec le marché aixois, pas une fois par an.",
          features: [
            "Analyse du marché local et ajustement des prix selon la saison, la demande et les événements aixois",
            "Gestion du calendrier voyageurs et propriétaire, avec blocage de vos dates personnelles",
            "Suivi des paiements et des factures",
            "Rapports réguliers de vos revenus et de votre taux d'occupation"
          ]
        },
        {
          title: "Assistance administrative",
          description: "Nous vous accompagnons dans vos démarches et vous alertons sur ce qui vous incombe.",
          features: [
            "Aide à vos démarches administratives",
            "Rédaction des contrats de location : baux saisonniers, baux mobilité, baux étudiants",
            "Formulaire d'enregistrement des voyageurs et collecte des pièces d'identité",
            "Conseils de mise en conformité et de sécurité, notamment sur les équipements réglementés"
          ]
        },
        {
          title: "Accueil, états des lieux et entretien",
          description: "Chaque rotation suit le même protocole, contrôlé pièce par pièce.",
          features: [
            "Accueil sur place ou accès autonome par boîte à clés, selon le bien et l'heure d'arrivée",
            "Présentation du logement et de son fonctionnement aux voyageurs",
            "États des lieux d'entrée et de sortie sur les réservations en direct, photos à l'appui",
            "Inventaire régulier du mobilier et des équipements",
            "Ménage professionnel de niveau hôtelier après chaque départ",
            "Lavage, séchage et préparation hôtelière des lits à chaque rotation",
            "Réapprovisionnement des consommables"
          ]
        },
        {
          title: "Gestion des imprévus",
          description: "Un problème pendant un séjour ne doit pas devenir le vôtre.",
          features: [
            "Interventions urgentes : serrurerie, plomberie, électricité, nuisibles",
            "Gestion des litiges voyageurs et des dégradations du logement ou des équipements",
            "Remplacement des articles endommagés, financé par la caution ou l'assurance",
            "Assistance et maintenance 7 jours sur 7"
          ]
        },
        {
          title: "E-réputation",
          description: "Les avis de vos voyageurs construisent la valeur locative de votre bien. Nous y consacrons le temps qu'ils méritent.",
          features: [
            "Réponse personnalisée à chaque commentaire",
            "Sollicitation des retours auprès des voyageurs satisfaits",
            "Suivi de vos notes et actions correctives"
          ]
        },
        {
          title: "Services aux voyageurs",
          description: "Un séjour réussi produit un bon avis, et un bon avis produit la réservation suivante.",
          features: [
            "Recommandations de restaurants, marchés et adresses locales, adaptées à chaque voyageur",
            "Proposition d'activités et d'expériences en Provence",
            "Coordination des demandes particulières",
            "Accueil en français et en anglais"
          ]
        }
      ],
      extras: {
        title: "Prestations complémentaires",
        items: [
          "Entretien de la piscine et du spa",
          "Entretien du jardin",
          "Ménage de remise en état ou de fin de période locative",
          "Création de la page de réservation en direct de votre logement"
        ]
      },
      advantages: {
        title: "Pourquoi la location saisonnière",
        items: [
          "Une rentabilité généralement supérieure à celle de la location classique",
          "Le règlement s'effectue à la réservation",
          "Une commission calculée uniquement sur les revenus réellement générés",
          "Une flexibilité tarifaire selon l'offre et la demande",
          "La possibilité de récupérer votre bien ou d'y séjourner quand vous le souhaitez"
        ]
      },
      advantageBadges: [
        "Ménage et linge inclus",
        "Paiement à la réservation",
        "Commission au succès",
        "Stratégie hybride bail mobilité",
        "Promotion réseaux sociaux & Google Ads",
        "Canal de réservation en direct"
      ],
      ctaTitle: "Estimez le Potentiel de Votre Bien",
      ctaDescription: "Obtenez une estimation gratuite de vos revenus locatifs et découvrez ce que notre accompagnement peut apporter à votre bien.",
      ctaButton: "Demander une estimation gratuite",
      homeKeyPoints: [
        "Shooting photo et vidéo par drone",
        "Diffusion Airbnb, Booking, Abritel, Vrbo, Expedia",
        "Ménage et blanchisserie inclus",
        "Stratégie hybride saisonnier / bail mobilité"
      ]
    },
    aLaCarte: {
      seoTitle: "Prestations à la carte Aix-en-Provence | Ménage, linge et consommables",
      seoDescription: "Ménage entre chaque séjour, linge et consommables pour votre location saisonnière à Aix-en-Provence. Sans commission ni engagement : ménage dès 55 € par rotation, linge dès 10 €, consommables 12 € par rotation.",
      heroTitle: "Prestations à la carte",
      heroSubtitle: "Sans commission",
      heroDescription: "Ménage, linge et consommables. Vous gérez vous-même vos réservations et souhaitez déléguer l'exploitation sur place. Nos prestations s'achètent à l'intervention : pas de commission sur vos revenus, pas d'engagement de durée.",
      cleaning: {
        title: "Ménage entre chaque séjour",
        columns: ["Type de logement", "Surface", "Par rotation"],
        rows: [
          ["Studio ou T1", "jusqu'à 35 m²", "55 €"],
          ["T2", "35 à 60 m²", "70 €"],
          ["T3", "60 à 90 m²", "85 €"],
          ["T4", "90 à 120 m²", "100 €"],
          ["Maison ou villa", "120 m² et plus", "Sur devis, à partir de 130 €"]
        ],
        includesTitle: "Chaque intervention comprend :",
        includes: [
          "Sols aspirés et lavés, dépoussiérage complet du mobilier et des surfaces",
          "Cuisine : plans de travail, évier, plaques, réfrigérateur, micro-ondes, cafetière, façades de placards",
          "Salle de bain et sanitaires : douche, lavabo, robinetterie, miroirs, évacuations",
          "Vitres intérieures, poignées et points de contact",
          "Poubelles vidées et sacs remplacés",
          "Vérification des objets oubliés et contrôle sous les lits",
          "Photographies pièce par pièce après intervention",
          "Signalement immédiat de toute anomalie ou dégradation"
        ]
      },
      linen: {
        title: "Linge",
        columns: ["", "Par rotation"],
        rows: [
          ["Lit double", "20 €"],
          ["Lit simple", "10 €"]
        ],
        note: "Le forfait s'applique par lit effectivement préparé et comprend le linge de bain des occupants de ce couchage. Le linge reste celui du propriétaire.",
        items: [
          "Dépose du linge propre dans le logement",
          "Préparation hôtelière du lit",
          "Récupération du linge utilisé, lit et bain",
          "Lavage et séchage",
          "Pliage et remise en stock dans le logement"
        ]
      },
      consumables: {
        title: "Consommables",
        price: "12 € par rotation",
        description: "Vous ne gérez plus ni les courses, ni les ruptures. Le dosage est calibré par séjour et vous ne payez que les séjours réellement effectués.",
        detail: "Café, thé, sucre, sel, poivre, huile d'olive, papier toilette, essuie-tout, gel douche, shampooing, savon mains, lessive, liquide vaisselle, sacs poubelle et produits d'entretien courants. Achat, déplacement et réapprovisionnement compris."
      },
      complementary: {
        title: "Prestations complémentaires",
        items: [
          "Entretien de la piscine et du spa",
          "Entretien du jardin",
          "Ménage de remise en état ou de fin de période locative",
          "Création de la page de réservation en direct de votre logement"
        ]
      },
      conditions: {
        title: "Conditions",
        items: [
          "Interventions à réserver au moins 48 heures à l'avance",
          "Volume minimum de deux interventions par mois",
          "Matériel de ménage et produits d'entretien présents dans le logement",
          "Facturation mensuelle, règlement à 15 jours",
          "Supplément de déplacement de 10 € pour Vauvenargues et Saint-Marc-Jaumegarde",
          "Les créneaux d'intervention sont attribués selon disponibilité, la priorité revenant aux logements en gestion complète"
        ]
      },
      crossSell: {
        title: "Vous préférez tout déléguer ?",
        description: "Notre formule Gestion complète prend en charge l'annonce, la tarification, les réservations, l'accueil et l'exploitation, pour 20 % des revenus locatifs nets. Le ménage et le linge y sont réglés directement par les voyageurs : vous n'avancez aucun frais.",
        cta: "Découvrir la Gestion complète"
      },
      ctaTitle: "Un devis pour votre logement",
      ctaDescription: "Indiquez-nous la surface de votre bien et le nombre de couchages : nous vous répondons sous 24 heures.",
      ctaButton: "Demander un devis"
    },
    bailMobilite: {
      seoTitle: "Bail mobilité Aix-en-Provence | Stratégie hybride location saisonnière",
      seoDescription: "Bail mobilité à Aix-en-Provence : location saisonnière en haute saison, bail mobilité de 1 à 10 mois en basse saison. Gestion complète du bail, dossier Visale, sélection du locataire. Commission 10 % au-delà de trois mois.",
      heroTitle: "Bail mobilité à Aix-en-Provence : ne laissez plus votre bien dormir l'hiver",
      heroSubtitle: "Stratégie hybride",
      heroDescription: "Aix vit au rythme de ses saisons. De juin à septembre, les festivals, les visiteurs et les familles remplissent les logements. Le reste de l'année, beaucoup de propriétaires voient leur calendrier se vider. La stratégie hybride règle ce problème : location saisonnière pendant la haute saison, bail mobilité pendant les mois creux. Votre bien travaille douze mois sur douze, sans jamais vous être retiré durablement.",
      sections: [
        {
          title: "Ce qu'est le bail mobilité",
          description: "Créé par la loi ELAN de 2018, le bail mobilité est un contrat de location meublée d'un à dix mois, non renouvelable, réservé à des locataires en situation temporaire : études, stage, apprentissage, formation professionnelle, mission temporaire, mutation ou service civique, sur justificatif.",
          features: [
            "Aucune reconduction automatique : le bail s'arrête à sa date, sans congé à donner ni procédure à engager",
            "Aucun dépôt de garantie ne peut être demandé, la loi l'interdit. La garantie Visale d'Action Logement le remplace, gratuitement, et couvre impayés et dégradations",
            "Le locataire peut partir avec un mois de préavis, vous non : c'est la contrepartie de la souplesse"
          ]
        },
        {
          title: "Un cadre réglementaire plus léger",
          description: "Contrairement au meublé de tourisme, le bail mobilité ne nécessite ni enregistrement en mairie ni autorisation de changement d'usage. Dans un contexte où la réglementation de la location saisonnière se durcit, cette souplesse vous donne une seconde jambe, activable immédiatement, si les règles évoluent sur votre commune.",
          features: []
        },
        {
          title: "Qui loue en bail mobilité à Aix",
          description: "La demande est réelle et documentée par le tissu local. Ces profils cherchent un meublé prêt à vivre, pour une durée déterminée, dans un secteur bien desservi. C'est exactement ce que votre bien saisonnier propose déjà.",
          features: [
            "Étudiants d'Aix-Marseille Université, de Sciences Po Aix et des écoles supérieures du centre",
            "Stagiaires et alternants en entreprise sur des missions de trois à six mois",
            "Internes et personnels hospitaliers en poste temporaire",
            "Salariés en mutation ou en mission, le temps de trouver un logement définitif",
            "Chercheurs et enseignants invités"
          ]
        },
        {
          title: "Comment nous procédons",
          description: "Cinq étapes, du diagnostic à la reprise saisonnière.",
          features: [
            "Analyse de votre bien : emplacement, typologie, équipement, saisonnalité réelle observée. Tous les biens ne se prêtent pas à l'hybride, nous vous le dirons franchement",
            "Construction du calendrier annuel : la période saisonnière à préserver et la fenêtre à ouvrir au bail mobilité",
            "Recherche et sélection du locataire : diffusion, vérification des justificatifs d'éligibilité, constitution du dossier Visale",
            "Rédaction du bail et de ses annexes, état des lieux d'entrée et de sortie",
            "Suivi pendant l'occupation et remise en état pour la reprise saisonnière"
          ]
        },
        {
          title: "Notre commission",
          description: "Sur toute location d'une durée continue supérieure à trois mois, bail mobilité compris, notre commission passe de 20 % à 10 % des revenus locatifs. La gestion demande moins de rotations : il est normal que vous en profitiez.",
          features: []
        },
        {
          title: "Les limites, dites franchement",
          description: "Le bail mobilité n'est pas une solution universelle, et mieux vaut le savoir avant qu'après. Nous sécurisons chacun de ces points dans le dossier que nous constituons.",
          features: [
            "Le loyer mensuel est inférieur à ce que rapporterait le même bien en saisonnier plein. Il est en revanche garanti et sans rotation",
            "Le locataire peut partir avec un mois de préavis, ce qui laisse une fenêtre à recombler",
            "Le justificatif d'éligibilité doit être annexé au contrat, sans quoi le bail peut être requalifié en bail meublé d'un an",
            "La durée ne peut en aucun cas dépasser dix mois"
          ]
        }
      ],
      faqTitle: "Questions fréquentes",
      faq: [
        { question: "Puis-je récupérer mon bien pour l'été ?", answer: "Oui. C'est même la raison d'être du montage. Le bail mobilité s'arrête à sa date, sans reconduction ni congé à donner." },
        { question: "Faut-il un dépôt de garantie ?", answer: "Non, la loi l'interdit expressément. La garantie Visale le remplace et couvre les impayés comme les dégradations locatives." },
        { question: "Mon bien doit-il être déclaré en mairie ?", answer: "Pas au titre du bail mobilité. L'enregistrement concerne les meublés de tourisme, pas les baux d'habitation." },
        { question: "Quelle fiscalité ?", answer: "Les revenus relèvent du régime BIC en location meublée. Nous vous orientons vers votre comptable pour l'arbitrage entre micro-BIC et réel." },
        { question: "Et si mon bien n'est pas adapté ?", answer: "Nous vous le dirons. Certains biens, par leur emplacement ou leur configuration, restent plus rentables en saisonnier toute l'année." }
      ],
      ctaTitle: "Estimer le potentiel hybride de mon bien",
      ctaDescription: "Nous analysons votre calendrier et votre secteur, puis nous vous disons franchement si la stratégie hybride est pertinente pour votre bien.",
      ctaButton: "Demander une estimation"
    },
    conciergerie: {
      seoTitle: "Conciergerie Aix-en-Provence | Accueil, Entretien & Gestion de Votre Bien",
      seoDescription: "Service de conciergerie personnalisée à Aix-en-Provence. Check-in/check-out, entretien régulier, gestion des imprévus, services voyageurs. Assistance 7/7.",
      heroTitle: "Conciergerie Personnalisée à Aix-en-Provence",
      heroSubtitle: "Conciergerie",
      heroDescription: "Nous veillons au bon fonctionnement de votre bien et au confort de vos voyageurs, avec un interlocuteur unique à vos côtés au quotidien.",
      sections: [
        {
          title: "Check-in / Check-out & États des Lieux",
          description: "Un accueil professionnel et chaleureux pour vos voyageurs, avec un suivi rigoureux de l'état de votre bien.",
          features: [
            "Accueil personnalisé bilingue (français / anglais)",
            "Inventaire régulier du mobilier et des équipements",
            "État des lieux détaillé à chaque arrivée et départ",
            "Remise des clés et présentation du logement"
          ]
        },
        {
          title: "Entretien Régulier",
          description: "Un entretien impeccable de votre bien grâce à notre réseau de prestataires qualifiés et nos outils de suivi modernes.",
          features: [
            "Gestion des contrats prestataires (ménage, maintenance, etc.)",
            "Rédaction d'un guide d'entretien prestataires",
            "Mise à disposition d'une application mobile prestataires pour gestion et suivi des services d'entretien",
            "Nettoyage quotidien et blanchisserie (réalisé sur place lors du ménage)"
          ]
        },
        {
          title: "Gestion des Imprévus",
          description: "Réactivité et efficacité face aux situations imprévues pour protéger votre bien et résoudre rapidement tout problème.",
          features: [
            "Gestion des pannes et réparations urgentes (serrurier, plombier, électricien, nuisibles, etc.)",
            "Gestion des litiges voyageurs et dégradations logement / équipements",
            "Remplacement des articles endommagés (financement via caution ou assurance)"
          ]
        },
        {
          title: "Services Voyageurs",
          description: "Des attentions et recommandations pensées pour rendre chaque séjour mémorable et susciter l'envie de revenir.",
          features: [
            "Proposition d'activités touristiques et expériences locales",
            "Chef à domicile et livraison de repas/courses",
            "Service de bagagerie",
            "Chauffeur privé et transferts",
            "Recommandations personnalisées restaurants et sorties"
          ]
        }
      ],
      atouts: {
        title: "Nos Atouts",
        items: [
          "1 seul interlocuteur qui connaît votre bien comme le sien",
          "Sélection rigoureuse des voyageurs (contrôle identité & avis)",
          "Assistance locale & maintenance 7/7",
          "Nettoyage professionnel & état des lieux après chaque réservation",
          "Amoureux de la région, nous sommes aussi guides touristiques !"
        ]
      },
      ctaTitle: "Confiez-Nous Votre Bien",
      ctaDescription: "Bénéficiez d'un service de conciergerie complet et personnalisé, avec un interlocuteur unique dédié à votre propriété.",
      ctaButton: "Nous contacter",
      homeKeyPoints: [
        "Assistance locale 7/7",
        "Accueil bilingue personnalisé",
        "Nettoyage pro à chaque location",
        "1 seul interlocuteur dédié"
      ]
    },
    staff: {
      seoTitle: "Staff Aix-en-Provence | Chefs, Ménage & Événements",
      seoDescription: "Personnel de maison à Aix-en-Provence. Chefs privés, personnel de ménage, service événementiel et garde d'enfants pour vos séjours ou événements en Provence.",
      heroTitle: "Staff",
      heroSubtitle: "Personnel de Maison",
      heroDescription: "Chefs privés, personnel de ménage et prestataires qualifiés pour vos séjours ou événements en Provence & Côte d'Azur.",
      sections: [
        { title: "Chefs Privés", description: "Des expériences gastronomiques à domicile avec nos chefs sélectionnés.", features: ["Chef à domicile pour vos séjours", "Menus sur mesure selon vos goûts", "Cours de cuisine avec spécialités locales", "Traiteur pour événements privés"] },
        { title: "Personnel de Ménage", description: "Un entretien impeccable de votre bien.", features: ["Nettoyage quotidien", "Préparation du logement avant chaque arrivée", "Blanchisserie et linge de maison", "Nettoyage en profondeur sur demande"] },
        { title: "Service Événementiel", description: "Du personnel professionnel pour vos réceptions.", features: ["Maîtres d'hôtel et serveurs", "Barmen et mixologistes", "Personnel de cuisine", "Coordination d'événements"] },
        { title: "Garde d'Enfants & Assistance", description: "Du personnel qualifié pour votre famille.", features: ["Baby-sitters qualifiés", "Accompagnement activités enfants", "Assistance personnelle", "Aide-ménagère"] }
      ],
      atouts: { title: "Nos Atouts", items: ["Sélection rigoureuse du personnel", "Flexibilité et disponibilité", "Prestataires locaux de confiance", "Personnel expérimenté et discret", "Service sur mesure"] },
      ctaTitle: "Besoin de Personnel ?",
      ctaDescription: "Contactez-nous pour organiser votre personnel de maison sur mesure.",
      ctaButton: "Nous contacter",
      homeKeyPoints: ["Chefs privés sur demande", "Personnel de ménage professionnel", "Service événementiel", "Taxi / Chauffeur privé"]
    },
    partnerBadge: "Service proposé en collaboration avec notre partenaire",
    partnerWhy: "Pourquoi Choisir Notre Partenaire",
    partnerLabel: "Partenaire",
    partnerExpertise: "sélectionné pour son expertise et son excellence",
    yachtCharter: {
      seoTitle: "Yacht Charter & Croisières Privées Côte d'Azur | Conciergerie Cabassol",
      seoDescription: "Charter de yachts et croisières privées en Méditerranée. Journée, coucher de soleil, semaine tout inclus. Service partenaire via Conciergerie Cabassol.",
      heroTitle: "Yacht Charter & Croisières Privées",
      heroSubtitle: "Service Partenaire",
      heroDescription: "Explorez les plus belles côtes de la Méditerranée à bord de yachts d'exception. Notre partenaire Alexander, expert en courtage nautique, vous propose des charters sur-mesure, de la journée découverte à la croisière d'une semaine tout inclus, avec équipage professionnel et itinéraires personnalisés.",
      sections: [
        {
          title: "Charters Journée & Croisières",
          description: "Des escapades maritimes adaptées à toutes vos envies, de la sortie coucher de soleil à la croisière hebdomadaire avec équipage complet.",
          features: [
            "Charters journée le long de la Côte d'Azur",
            "Sorties coucher de soleil avec apéritif à bord",
            "Croisières semaine tout inclus (équipage, restauration, activités nautiques)",
            "Itinéraires sur-mesure selon vos préférences"
          ]
        },
        {
          title: "Flotte & Équipage",
          description: "Une sélection rigoureuse de yachts de 15 à 50 mètres, chacun équipé des dernières technologies et doté d'un équipage professionnel expérimenté.",
          features: [
            "Yachts à moteur et voiliers de 15 à 50 mètres",
            "Équipage professionnel certifié et multilingue",
            "Chef cuisinier à bord sur demande",
            "Équipements nautiques complets (jet-ski, paddle, plongée)"
          ]
        },
        {
          title: "Événements à Bord",
          description: "Transformez votre yacht en lieu de réception pour des moments inoubliables : soirées privées, team building ou célébrations familiales dans un cadre unique.",
          features: [
            "Soirées privées et cocktails en mer",
            "Team building et séminaires d'entreprise",
            "Célébrations et anniversaires",
            "Service traiteur gastronomique à bord"
          ]
        },
        {
          title: "Destinations",
          description: "De la Côte d'Azur à la Corse en passant par la Sardaigne et les îles grecques, votre horizon n'a aucune limite.",
          features: [
            "Côte d'Azur : Saint-Tropez, Cannes, Monaco, Antibes",
            "Corse : Bonifacio, Porto-Vecchio, Calvi",
            "Sardaigne : Costa Smeralda, archipel de la Maddalena",
            "Îles grecques : Cyclades, Dodécanèse, Ionniennes"
          ]
        }
      ],
      atouts: {
        title: "Pourquoi Choisir Notre Partenaire",
        items: [
          "Expertise reconnue en courtage nautique depuis plus de 10 ans",
          "Flotte variée de yachts rigoureusement sélectionnés",
          "Service sur-mesure avec itinéraires personnalisés",
          "Équipage professionnel certifié et multilingue",
          "Disponibilité 7/7 pendant toute la saison",
          "Tarifs transparents sans frais cachés"
        ]
      },
      ctaTitle: "Embarquez pour l'Extraordinaire",
      ctaDescription: "Contactez-nous pour organiser votre croisière privée en Méditerranée via notre partenaire Alexander.",
      ctaButton: "Réserver via notre partenaire"
    },
    billetterie: {
      seoTitle: "Billetterie & Accès VIP Côte d'Azur | Conciergerie Cabassol",
      seoDescription: "Billetterie et accès VIP aux événements exclusifs de la Côte d'Azur. Festival de Cannes, F1 Monaco, galas privés. Service partenaire via Conciergerie Cabassol.",
      heroTitle: "Billetterie & Accès VIP",
      heroSubtitle: "Service Partenaire",
      heroDescription: "Accédez aux événements les plus exclusifs et prisés de la Côte d'Azur et au-delà. Notre partenaire Antoine, expert en événementiel de luxe, vous ouvre les portes des manifestations culturelles, sportives et mondaines les plus prestigieuses.",
      sections: [
        {
          title: "Festival de Cannes & Cinéma",
          description: "Vivez le Festival de Cannes comme un initié : projections officielles, soirées VIP sur les plages privées et avant-premières exclusives dans un cadre d'exception.",
          features: [
            "Invitations projections officielles Palais des Festivals",
            "Accès soirées privées sur les plages de la Croisette",
            "Avant-premières et projections VIP",
            "Rencontres avec acteurs et réalisateurs"
          ]
        },
        {
          title: "Mode & Art",
          description: "Plongez au cœur de la création contemporaine : Fashion Weeks, vernissages privés et expositions exclusives dans les galeries et fondations les plus prestigieuses.",
          features: [
            "Front row Fashion Weeks internationales",
            "Vernissages privés et rencontres artistes",
            "Expositions exclusives et collections privées",
            "Salons d'art contemporain (Art Basel, FIAC)"
          ]
        },
        {
          title: "Sport & Grand Prix",
          description: "Les événements sportifs les plus prestigieux avec des accès privilégiés : paddock F1 à Monaco, loges VIP lors des régates et matchs dans les meilleures conditions.",
          features: [
            "Grand Prix F1 de Monaco (paddock, yacht, terrasses VIP)",
            "Régates et événements nautiques (Voiles de Saint-Tropez)",
            "Matchs VIP dans les plus grands stades",
            "Tournois de golf et de tennis exclusifs"
          ]
        },
        {
          title: "Galas & Soirées Exclusives",
          description: "Des événements mondains réservés aux initiés : galas caritatifs, soirées de networking et célébrations privées dans les lieux les plus emblématiques.",
          features: [
            "Galas caritatifs et soirées de bienfaisance",
            "Événements networking haut de gamme",
            "Soirées privées dans les villas et yachts",
            "Concerts privés et événements sur invitation"
          ]
        }
      ],
      atouts: {
        title: "Pourquoi Choisir Notre Partenaire",
        items: [
          "Réseau privilégié d'accès aux événements les plus exclusifs",
          "Places garanties même pour les événements complets",
          "Accompagnement personnalisé avant et pendant l'événement",
          "Coordination complète (transport, dress code, protocole)",
          "Expertise événementielle depuis plus de 8 ans",
          "Accès aux coulisses et rencontres VIP"
        ]
      },
      ctaTitle: "Vivez l'Exception",
      ctaDescription: "Contactez-nous pour réserver vos accès VIP aux événements les plus prestigieux via notre partenaire Antoine.",
      ctaButton: "Réserver via notre partenaire"
    },
    automobiles: {
      seoTitle: "Automobiles de Prestige Côte d'Azur | Location Supercars & Expériences",
      seoDescription: "Location de supercars, expériences circuit, rallyes automobiles et chauffeur privé sur la Côte d'Azur. Service partenaire via Conciergerie Cabassol.",
      heroTitle: "Automobiles de Prestige",
      heroSubtitle: "Service Partenaire",
      heroDescription: "Vivez l'exception automobile sur les plus belles routes de Provence et de la Côte d'Azur. Notre partenaire Bowoods Travel, passionné et expert en véhicules de prestige, vous propose location de supercars, expériences circuit privatisées et service de chauffeur privé.",
      sections: [
        {
          title: "Location de Supercars",
          description: "Une collection exclusive de véhicules d'exception livrés directement à votre porte : Ferrari, Lamborghini, Porsche, McLaren et bien d'autres marques de prestige.",
          features: [
            "Livraison et reprise personnalisées à votre adresse",
            "Flotte variée : sportives, GT, cabriolets, berlines de luxe",
            "Assurance tous risques premium incluse",
            "Kilométrage flexible adapté à vos besoins"
          ]
        },
        {
          title: "Expériences Circuit",
          description: "Des journées inoubliables sur les circuits les plus prestigieux du Sud de la France avec coaching pilotage professionnel et véhicules de course.",
          features: [
            "Journées circuit privatisées (Paul Ricard, Lédenon)",
            "Coaching pilotage avec instructeurs professionnels",
            "Accès à des véhicules de course et supercars",
            "Formules individuelles ou groupes (team building, EVJG)"
          ]
        },
        {
          title: "Rallyes & Rassemblements",
          description: "Participez aux événements automobiles les plus prestigieux de la région : rallyes touristiques, rassemblements de collectionneurs et road trips exclusifs.",
          features: [
            "Organisation de rallyes touristiques sur-mesure",
            "Participation aux rassemblements de supercars et collections",
            "Road trips exclusifs sur les routes mythiques de Provence",
            "Visites privées de musées et collections automobiles"
          ]
        },
        {
          title: "Chauffeur Privé",
          description: "Un service de chauffeur privé haut de gamme pour vos transferts, circuits touristiques et événements, avec des véhicules premium et une discrétion absolue.",
          features: [
            "Transferts aéroport, gare et héliport",
            "Circuits touristiques personnalisés en Provence",
            "Service événementiel (mariages, galas, soirées)",
            "Disponibilité 24/7 avec réservation à la demande"
          ]
        }
      ],
      atouts: {
        title: "Pourquoi Choisir Notre Partenaire",
        items: [
          "Flotte exclusive de véhicules rigoureusement entretenus",
          "Livraison porte-à-porte partout sur la Côte d'Azur",
          "Assurance premium tous risques incluse",
          "Connaissance parfaite des plus belles routes de la région",
          "Service client dédié et réactif 7/7",
          "Tarifs compétitifs et transparents"
        ]
      },
      ctaTitle: "Prenez le Volant de l'Exception",
      ctaDescription: "Contactez-nous pour réserver votre véhicule de prestige ou organiser votre expérience automobile via notre partenaire Bowoods Travel.",
      ctaButton: "Réserver via notre partenaire"
    }
  },
  seo: {
    home: { title: "Conciergerie & Gestion Locative", description: "Services de conciergerie et gestion locative de biens immobiliers d'exception en Provence & Côte d'Azur." },
    services: { title: "Nos Services - Gestion Locative, Conciergerie & Yacht Charter", description: "Découvrez nos services sur-mesure : gestion locative, conciergerie personnalisée, yacht charter et expériences exclusives." },
    about: { title: "À Propos - Notre Histoire et Notre Équipe", description: "Découvrez Conciergerie Cabassol, expert en services sur-mesure sur la Côte d'Azur depuis 2020." },
    contact: { title: "Contact - Prenez Rendez-vous avec Notre Équipe", description: "Contactez Conciergerie Cabassol pour vos besoins en gestion locative, conciergerie et services sur-mesure." },
    blog: { title: "Blog - Conseils Gestion Locative & Immobilier de Luxe", description: "Découvrez nos articles experts sur la gestion locative de luxe et l'investissement immobilier." },
    legal: { title: "Mentions Légales & Politique de Confidentialité", description: "Mentions légales et politique de confidentialité de Conciergerie Cabassol." },
    apartments: { title: "Hébergements de Prestige en Provence & Côte d'Azur", description: "Découvrez notre sélection de villas et appartements d'exception à Aix-en-Provence, Saint-Tropez, Cannes et Nice." }
  }
};
